import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import themeService from './services/themeService'

// تهيئة الثيم عند تحميل التطبيق
themeService.watchSystemPreference();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)